import { appConfig } from '../../../config/customization';

export default {
  table: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: `4px solid ${appConfig.colors.sidebarColor}`,
    borderRadius: 4,
    margin: '3% 35px'
  }
};
